<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Budgets',
        route: { name: 'sales-budgets' }
      }
    }
  }
}
</script>
